module.exports = __webpack_public_path__ + "static/media/w.d262a1b5.png";